import { merge } from 'lodash-es';

import {
  DEFAULT_AXIS_HIDDEN,
  DEFAULT_NUMERICAL_AXIS_TYPE,
} from '../../../constants.js';
import {
  isNumericalAxis,
  isTimestampAxis,
  XAxisConfig,
  XAxisConfigProps,
  XAxisProps,
} from '../types/annotations-x-axis-props.js';

const DEFAULT_AXIS = {
  hidden: DEFAULT_AXIS_HIDDEN,
};

const DEFAULT_NUMERICAL_AXIS = {
  ...DEFAULT_AXIS,
  type: DEFAULT_NUMERICAL_AXIS_TYPE,
};

const parseConfigAxisToDate = (axisConfig: XAxisConfigProps) => {
  let configMin = axisConfig?.min;
  let configMax = axisConfig?.max;

  if (typeof axisConfig?.min === 'string') {
    configMin = new Date(axisConfig.min);
  }
  if (typeof axisConfig?.max === 'string') {
    configMax = new Date(axisConfig.max);
  }

  return {
    ...axisConfig,
    min: configMin,
    max: configMax,
  };
};

export const populateMissingAxisProps = (
  axis: XAxisProps,
  hasNumericalData: boolean,
  axisConfig?: XAxisConfigProps,
): XAxisConfig => {
  if (isNumericalAxis(axis)) {
    return merge({}, DEFAULT_NUMERICAL_AXIS, axisConfig, axis);
  }

  if (hasNumericalData && !isTimestampAxis(axis)) {
    return merge({}, DEFAULT_NUMERICAL_AXIS, axisConfig, axis);
  }

  const parsedAxisConfig = axisConfig
    ? parseConfigAxisToDate(axisConfig)
    : axisConfig;

  return merge({}, DEFAULT_AXIS, parsedAxisConfig, axis);
};
